/**
 * @description ImageFluxのURLを生成するヘルパー関数
 * @param baseUrl - ImageFluxのベースURL
 * @param options - URL生成オプション
 * @returns ImageFluxのURL
 * @see https://console.imageflux.jp/docs/image/conversion-parameters
 */
export function createImageFluxUrl(
  baseUrl: string,
  options: {
    /** @description S3上の画像パス */
    path: string;
    /** @description 画像の横幅 */
    w?: number;
    /** @description 画像の縦幅 */
    h?: number;
  },
): string {
  const { w, h, path } = options;

  const paramsObj = {
    a: 2,
    w,
    h,
  };

  // NOTE: Objectを `w=100,h=100,foo=bar,...` のようなの文字列に変換する
  const params = (Object.keys(paramsObj) as Array<keyof typeof paramsObj>)
    .filter((key) => paramsObj[key] !== undefined)
    .map((key) => {
      return `${key}=${paramsObj[key]}`;
    })
    .join(',');

  return `${baseUrl}/${params}/${path}`;
}
